import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import Result from '../../_interface/result';
import NebulaModuleBase from './module-base';
import { UpUser } from './upuser';
import { UpVDN } from './upvdn';
export var UpAi = function (_NebulaModuleBase) {
    _inherits(UpAi, _NebulaModuleBase);

    function UpAi() {
        _classCallCheck(this, UpAi);

        return _possibleConstructorReturn(this, (UpAi.__proto__ || Object.getPrototypeOf(UpAi)).apply(this, arguments));
    }

    _createClass(UpAi, [{
        key: 'sdkInit',
        value: function sdkInit(param) {
            return this.generatePromiseByFunctionWithParams('sdkInitForAi', param);
        }
    }, {
        key: 'sdkRelease',
        value: function sdkRelease() {
            return this.generatePromiseByFunctionWithParams('sdkReleaseForAi', null);
        }
    }, {
        key: 'initOk',
        value: function initOk() {
            return this.generatePromiseByFunctionWithParams('initOkForAi', null);
        }
    }, {
        key: 'createAsrRecorder',
        value: function createAsrRecorder() {
            return this.generatePromiseByFunctionWithParams('createAsrRecorderForAi', null);
        }
    }, {
        key: 'attachAsrRecorder',
        value: function attachAsrRecorder(params) {
            this.asrErrorHandleListener = params.AsrErrorListener;
            this.asrRsultHandleListener = params.AsrRsultListener;
            this.asrEventHandleListener = params.AsrEventListener;
            this.asrVolumeHandleListener = params.AsrVolumeListener;
            var event = 'AsrEvent';
            var param = {
                eventName: event
            };
            return this.generatePromiseByAttachListenerWithParams(event, this.recorderListener, 'attachAsrRecorderForAi', param);
        }
    }, {
        key: 'recorderListener',
        value: function recorderListener(ret) {
            switch (ret.event) {
                case 'onAsrError':
                    this.asrErrorHandleListener(ret.data);
                    break;
                case 'onAsrResult':
                    this.asrRsultHandleListener(ret.data);
                    break;
                case 'onAsrEvent':
                    this.asrEventHandleListener(ret.data);
                    break;
                case 'onAsrVolume':
                    this.asrVolumeHandleListener(ret.data);
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'detachAsrRecorder',
        value: function detachAsrRecorder() {
            var event = 'AsrEvent';
            var param = {
                eventName: event
            };
            return this.generatePromiseByDetachListenerWithParams(event, this.recorderListener, 'detachAsrRecorderForAi', param);
        }
    }, {
        key: 'startAsrRecorder',
        value: function startAsrRecorder(param) {
            return this.generatePromiseByFunctionWithParams('startAsrRecorderForAi', param);
        }
    }, {
        key: 'cancelAsrRecorder',
        value: function cancelAsrRecorder() {
            return this.generatePromiseByFunctionWithParams('cancelAsrRecorderForAi', null);
        }
    }, {
        key: 'stopAsrRecorder',
        value: function stopAsrRecorder() {
            return this.generatePromiseByFunctionWithParams('stopAsrRecorderForAi', null);
        }
    }, {
        key: 'createTtsPlayer',
        value: function createTtsPlayer() {
            return this.generatePromiseByFunctionWithParams('createTtsPlayerForAi', null);
        }
    }, {
        key: 'attachTts',
        value: function attachTts(params) {
            this.ttsErrorHandleListener = params.TtsErrorListener;
            this.ttsRsultHandleListener = params.TtsRsultListener;
            this.ttsEventHandleListener = params.TtsEventListener;
            var event = 'TtsEvent';
            var param = {
                eventName: event
            };
            return this.generatePromiseByAttachListenerWithParams(event, this.ttsListener, 'attachTtsForAi', param);
        }
    }, {
        key: 'ttsListener',
        value: function ttsListener(ret) {
            switch (ret.event) {
                case 'onTtsError':
                    this.ttsErrorHandleListener(ret.data);
                    break;
                case 'onTtsResult':
                    this.ttsRsultHandleListener(ret.data);
                    break;
                case 'onTtsEvent':
                    this.ttsEventHandleListener(ret.data);
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'detachTts',
        value: function detachTts() {
            var event = 'TtsEvent';
            var param = {
                eventName: event
            };
            return this.generatePromiseByDetachListenerWithParams(event, this.ttsListener, 'detachTtsForAi', param);
        }
    }, {
        key: 'startTts',
        value: function startTts(param) {
            return this.generatePromiseByFunctionWithParams('startTtsForAi', param);
        }
    }, {
        key: 'stopTts',
        value: function stopTts() {
            return this.generatePromiseByFunctionWithParams('stopTtsForAi', null);
        }
    }, {
        key: 'playTts',
        value: function playTts(param) {
            return this.generatePromiseByFunctionWithParams('playTtsForAi', param);
        }
    }, {
        key: 'pauseTts',
        value: function pauseTts() {
            return this.generatePromiseByFunctionWithParams('pauseTtsForAi', null);
        }
    }, {
        key: 'openSpeechView',
        value: function openSpeechView(corpus) {
            var _this2 = this;

            window.console.info('getCharacteristicsValue', corpus);
            return new Promise(function (resolve, reject) {
                new UpUser().getLoginStatus().then(function (result) {
                    var _a;
                    if (((_a = result.retData) === null || _a === void 0 ? void 0 : _a.isLogin) === false && result.retData.isLogining === false) {
                        // 通过VDN跳转到登录页面
                        new UpVDN().goToPage({ url: 'http://uplus.haier.com/uplusapp/login.html' }).then(function (resultVdn) {
                            if (resultVdn.retCode === '000000') {
                                window.console.info('跳转登录页成功', resultVdn);
                                resolve(new Result('000000', '\u8DF3\u8F6C\u767B\u5F55\u9875\u6210\u529F', resultVdn.retData));
                            } else {
                                window.console.info('跳转登录页失败', resultVdn);
                                reject(new Result('000001', '\u8DF3\u8F6C\u767B\u5F55\u9875\u5931\u8D25', resultVdn.retData));
                            }
                        });
                    } else {
                        _this2.generatePromiseByFunctionWithParams('openSpeechView', corpus);
                    }
                })['catch'](function (err) {
                    window.console.info('getLoginStatus err', err);
                    reject(new Result('000001', '\u6253\u5F00\u8BED\u97F3\u6D6E\u7A97\u5931\u8D25', err));
                });
            });
        }
    }, {
        key: 'closeSpeechView',
        value: function closeSpeechView() {
            return this.generatePromiseByFunctionWithParams('closeSpeechView', null);
        }
    }]);

    return UpAi;
}(NebulaModuleBase);